import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const updateConfig = createAsyncThunk(
    "updateConfig",
    async ({ type, requestData }, thunkAPI) => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.put(`/api/v1/integration/config/update/${type}`, requestData);
            return response.data; 
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

const updateConfigSlice = createSlice({
    name: "updateConfig",
    initialState: {
        loading: false,
        error: null,
        data: [], 
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateConfig.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateConfig.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.data.findIndex(config => config.id === action.payload.id);
                if (index !== -1) {
                    state.data[index] = action.payload; 
                } else {
                    state.data.push(action.payload);
                }
            })
            .addCase(updateConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default updateConfigSlice.reducer;
